/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/scheduleList.config.json";
import sam_comfig from "../config/schedule.config.json";
import axios from "axios";
import { LoggerModule } from "@vlinder-web/logger-module-react";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_SCHEDULED_USER_LIST } from "../graphql";
import { VApplication } from "../../../application";
import moment from "moment-timezone";
import { capitalCase } from "change-case";
import { StorageModule } from "@vlinder-web/storage-module-react";

const log: any = LoggerModule?.getInstance();
const storageService = StorageModule.getInstance();

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IScheduleListMethods extends IPluginMethodMap {
  getScheduleList(args: any): Promise<any>;
}

export class ScheduleListService implements IAgentPlugin {
  readonly methods: IScheduleListMethods;

  constructor() {
    this.methods = {
      getScheduleList: this.getScheduleList.bind(this),
    };
  }

  async getScheduleList(args: any) {
    log.blue(`getScheduleList server component:`, args);
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    console.log(
      "Here ",
      storageService.get("bandConfig", "local")?.band?.appCardId
    );

    try {
      if (client) {
        const res = await client.query({
          query: GET_SCHEDULED_USER_LIST,
          variables: {
            options: {
              limit: args?.size ?? 10,
              skip: args?.offset ?? 0,
            },
            filter: {
              ...args?.criteria,
              band__in: [
                storageService.get("bandConfig", "local")?.band?.appCardId ??
                  null,
              ],
              isPublished: true,
            },
          },
          fetchPolicy: "network-only",
        });
        // const res: any = sam_comfig;
        if (res?.data) {
          let _totalPages = res?.data?.getSchedules?.count
            ? parseInt(res?.data?.getSchedules?.count) / 10
            : 1;
          let _currentPage =
            res?.data?.getSchedules?.skip / res?.data?.getSchedules?.limit + 1;
          return {
            ...config,
            bandName:
              storageService.get("currencyExchangeLocal", "local")?.band ??
              null,
            bandId:
              storageService.get("currencyExchangeLocal", "local")?.bandId ??
              null,
            isEmpty: res?.data?.getSchedules?.content?.length <= 0,
            ultUsers: this._getUserData(res?.data?.getSchedules?.content),
            activePage: _currentPage,
            pageSize: res?.data?.getSchedules?.limit,
            totalCount: res?.data?.getSchedules?.count,
            totalPages: _totalPages,
          };
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      return {
        isEmpty: true,
      };
    }
  }

  private _getUserData = (data: any) => {
    let _res: any[] = [];
    data &&
      Array.isArray(data) &&
      data.length > 0 &&
      data.map((item: any, index: number) => {
        _res.push({
          id: item?.id,
          name: item?.name,
          scheduleID: item?.scheduleID,
          band: item?.band?.name,
          attendeesCount: item?.attendeesCount,
          eventTime: this.formatEventTime(
            item?.eventStartTime,
            item?.eventEndTime
          ),
        });
      });

    return _res;
  };

  private formatEventTime = (startTime: any, endTime: any) => {
    const metaData = storageService.get("bandConfig", "local")?.metaData;
    if (startTime && endTime) {
      let _date = moment.tz(startTime, metaData?.tmz).format("DD MMM YYYY");
      let _start = moment.tz(startTime, metaData?.tmz).format("hh:mm A");
      let _end = moment.tz(endTime, metaData?.tmz).format("hh:mm A");
      // return `${_date} ${_start} - ${_end} ${metaData?.abbrevation}`;
      return `${_date} ${_start} - ${_end} AST`;
    }
    return " - ";
  };

  private formatDelegate = (delegate: any) => {
    if (delegate) {
      let _delegate = delegate?.collectorType
        ? delegate?.collectorType.toLowerCase() === "myself"
          ? "Self"
          : delegate?.name
        : " - ";
      return _delegate;
    }
  };

  private formatPhoneNo = (user: any) => {
    if (user?.primaryContactNo) {
      return user?.primaryContactNo;
    } else {
      let _phone = user?.phoneNumbers;
      if (_phone && Array.isArray(_phone) && _phone?.length > 0) {
        return _phone[0]?.number;
      }
      return null;
    }
  };

  private formatCreatedDate(date: Date) {
    const metaData = storageService.get("bandConfig", "local")?.metaData;
    console.log(`metaData`, metaData);
    if (date && metaData) {
      let _date = `${moment.tz(date, metaData?.tmz).format("LLL")} ${
        metaData?.abbrevation
      }`;
      console.log(`_date`, _date);
      return _date;
    }
  }

  private getFormattedStatus(status: string, suspended: boolean) {
    if (suspended) {
      return "suspended";
    } else {
      switch (status) {
        case "USER_ADDED":
          return "created";
        case "INVITED":
          return "invited";
        case "EMAIL_VERIFIED":
          return "verified";
        case "ACC_CREATED":
          return "active";
        case "WALLET_REGISTERED":
          return "active";
        case "SUSPENDED":
          return "suspended";
        default:
          return "-";
      }
    }
  }
}
